export default {
  namespaced: true,
  state: () => ({
    width: 0,
    height: 0,
  }),
  mutations: {
    changeWidth(state, payload) {
      state.width = payload;
    },

    changeHeight(state, payload) {
      state.height = payload;
    },
  },
  actions: {
  },
};
